import { useCallback, useState } from 'react';

/** What the owner's player page shows: the game to play, or the game's scenes to edit. */
export type PlayerTab = 'game' | 'scenes';

/**
 * The player page's tab for one project. The page always opens on 'game'; a chosen tab lasts while the page shows that
 * project, and only while the tuning editor is shown does the tab leave 'game'.
 */
export function usePlayerTab(projectId: string, editorShown: boolean): [PlayerTab, (tab: PlayerTab) => void] {
  const [chosen, setChosen] = useState<{ projectId: string; tab: PlayerTab } | null>(null);

  const choose = useCallback(
    (next: PlayerTab) => {
      if (editorShown) setChosen({ projectId, tab: next });
    },
    [projectId, editorShown],
  );

  return [editorShown && chosen?.projectId === projectId ? chosen.tab : 'game', choose];
}
